import React, { useEffect, useState } from "react";

const InputNumberField = ({
  className,
  inputMax = 10,
  inputMin = 0,
  onChangeValue,
  initialValue,
  isWarning = false,
  disabled = false,
  increaseQtyHandler = null,
  decreaseQtyHandler = null,
}) => {
  const [tempValue, setTempValue] = useState(initialValue);

  useEffect(() => {
    onChangeValue(tempValue);
  }, [tempValue]);

  useEffect(() => {
    setTempValue(initialValue);
  }, [initialValue]);

  const inputOnChangeHandler = (e) => {
    const enteredVal = e.target.value.trim();
    if (enteredVal.length > 0) {
      const val = Math.min(parseInt(enteredVal), inputMax);
      setTempValue(val);
    } else {
      setTempValue(0);
    }
  };

  const minusButtonOnClickHandler = (e) => {
    setTempValue((prevState) => prevState - 1);
    if (typeof decreaseQtyHandler === "function") {
      decreaseQtyHandler();
    }
  };
  const plusButtonOnClickHandler = (e) => {
    setTempValue((prevState) => prevState + 1);
    if (typeof increaseQtyHandler === "function") {
      increaseQtyHandler();
    }
  };

  const isButtonDisabled = inputMax <= tempValue || inputMax < initialValue || disabled

  return (
    <div
      className={`${className} number-input-field ${
        isWarning ? "warning" : ""
      }`}
    >
      <button
        className="toggle-qty"
        disabled={inputMin >= tempValue || inputMin > initialValue || disabled}
        onClick={minusButtonOnClickHandler}
        type="button"
      >
        −
      </button>
      <input
        disabled={disabled}
        max={inputMax}
        min={inputMin}
        onChange={inputOnChangeHandler}
        type="number"
        value={tempValue?.toString()}
      />
      <button
        className="toggle-qty"
        disabled={isButtonDisabled}
        onClick={plusButtonOnClickHandler}
        type="button"
      >
        +
      </button>
    </div>
  );
};

export default React.memo(InputNumberField);
